import { render, staticRenderFns } from "./addInsight.vue?vue&type=template&id=34a07bb4"
import script from "./addInsight.vue?vue&type=script&lang=js"
export * from "./addInsight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports